import styled from "styled-components";

export const ComingSoonWrapper = styled.div.attrs({
  className:
    "bg-accentsBlue flex justify-center items-center w-full md:min-h-screen lg:min-h-full xl:min-h-screen  relative",
})`
  @media only screen and (min-width: 1024px) {
    height: 80vh;
  }
  @media only screen and (min-width: 1200px) {
    height: 80vh;
  }

  @media only screen and (max-width: 768px) {
    height: 80vh;
`;
